'use strict';

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoadingOverlayController = function LoadingOverlayController($scope, $element, loadingOverlayService) {
    _classCallCheck(this, LoadingOverlayController);

    this.loadingOverlayService = loadingOverlayService;
    if (this.dynamicSize == 'true') {
        var resize = function resize() {
            var parent = $($element).parent();
            var e = $($element).find('.loading-overlay');
            e.css('width', parent.outerWidth());
            e.css('height', parent.outerHeight());
        };

        $scope.$on('resizeOverlay', resize);
        $(window).resize(resize);
    }

    if (loadingOverlayService.webComponent) {
        $element[0].classList.add('winres-web-component');
    }
};

LoadingOverlayController.$inject = ['$scope', '$element', 'loadingOverlayService'];

_module3.default.component('loadingOverlay', {
    restrict: 'EA',
    template: require('./loadingOverlay.html'),
    controller: LoadingOverlayController,
    bindings: {
        // If true, updates width and height based on parent element.
        'dynamicSize': '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/core/loadingOverlay.js
// module id = 68
// module chunks = 0 2